import EmbedReducer from './reducer';
import embedSaga from './saga';
import * as embedActions from './actions';

export {embedSaga, embedActions};
export default EmbedReducer;